export const initialState = {
  actionProcessing: false,
  usersList: {
    users: [],
    quantity: 0,
    totalBalance: 0,
  },
  newPassword: '',
};